import { Icon } from "@chakra-ui/react";
const SuccessGreenIcon = () => {
  return (
    <>
      <Icon
        xmlns="http://www.w3.org/2000/svg"
        width="6"
        height="6"
        viewBox="0 0 16 16"
      >
        <path
          id="righttime"
          d="M8,16a8,8,0,1,0-5.657-2.343A8,8,0,0,0,8,16Zm3.531-9.469-4,4a.747.747,0,0,1-1.059,0l-2-2A.749.749,0,0,1,5.531,7.472L7,8.941l3.469-3.472a.749.749,0,0,1,1.059,1.059Z"
          fill="#39c449"
        />
      </Icon>
    </>
  );
};
export default SuccessGreenIcon;
